/** Saves part of a project (members, links, metric settings) through the services, with the success message of that change. */
import type { ProjectPatch } from '@/types/models';
import { useAction } from '@/hooks/data';

export function useProjectPatch(projectId: string) {
  const a = useAction(
    (s, patch: ProjectPatch, _success: string) => s.projects.update(projectId, patch),
    (_r, _patch, success) => success,
  );
  return { run: (patch: ProjectPatch, success: string) => a.run(patch, success), pending: a.pending };
}
